import RootState from 'store/state';
import { useSelector } from 'react-redux';

export default function useQueuedTasks(): RootState["queuedTasks"] {

    const queuedTasks = useSelector<RootState, RootState["queuedTasks"]>(
        ({ queuedTasks }) => queuedTasks
    )

    return queuedTasks
}
